<template>
  <validation-observer ref="observer" tag="fieldset">
    <b-card-body>
      <b-row v-if="hasPerformerCollege()">
        <b-col>
          {{ $t("performer") | capitalize }}:
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="hasPerformerCollege()">
        <b-col>
          <distribution-form-group
            vid="openPeriodStartPerformer"
            ref="openPeriodStartPerformer"
            :label="$t('open_period_start_date') | capitalize"
            :description="$t('open_period_start_date_help_text') | capitalize"
            label-cols="2"
            v-slot="{ state }"
            >
            <date-picker
              :disabled="true"
              type="date"
              v-model="distribution.openPeriodStartPerformer"
              :class="{invalid: state === false}"
              :format="$config.DATE_FORMAT"
            />
          </distribution-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="hasPerformerCollege()">
        <b-col>
          <distribution-form-group
            vid="openPeriodEndPerformer"
            ref="openPeriodEndPerformer"
            :label="$t('open_period_end_date') | capitalize"
            :description="$t('performer_open_period_end_date_help_text') | capitalize"
            label-cols="2"
            v-slot="{ state }"
            >
            <date-picker
              :disabled="true"
              type="date"
              v-model="distribution.openPeriodEndPerformer"
              :class="{invalid: state === false}"
              :format="$config.DATE_FORMAT"
            />
          </distribution-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="hasMakerCollege()">
        <b-col>
          {{ $t("maker") | capitalize }}:
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="hasMakerCollege()">
        <b-col>
          <distribution-form-group
            vid="openPeriodStartMaker"
            ref="openPeriodStartMaker"
            :label="$t('open_period_start_date') | capitalize"
            :description="$t('open_period_start_date_help_text') | capitalize"
            label-cols="2"
            v-slot="{ state }"
            >
            <date-picker
              :disabled="true"
              type="date"
              v-model="distribution.openPeriodStartMaker"
              :class="{invalid: state === false}"
              :format="$config.DATE_FORMAT"
            />
          </distribution-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="hasMakerCollege()">
        <b-col>
          <distribution-form-group
            vid="openPeriodEndMaker"
            ref="openPeriodEndMaker"
            :label="$t('open_period_end_date') | capitalize"
            :description="$t('maker_open_period_end_date_help_text') | capitalize"
            label-cols="2"
            :value-type="$config.ISO_DATE_FORMAT"
            v-slot="{ state }"
            >
            <date-picker
              :disabled="true"
              type="date"
              v-model="distribution.openPeriodEndMaker"
              :class="{invalid: state === false}"
              :format="$config.DATE_FORMAT"
            />
          </distribution-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </validation-observer>
</template>

<script>

import DistributionFormGroup from "@/components/DistributionFormGroup"
import { ValidationObserver } from "vee-validate"
import { distributionCollegeTypes } from "@/constants"
import { distributionSectionMixin } from "@/utils/mixins"
import moment from "moment"
import parseDate from "@/utils/date-parser"

export default {
  name: "OpenPeriodSection",
  components: { DistributionFormGroup, ValidationObserver },
  mixins: [ distributionSectionMixin ],
  props: {
    distribution: Object
  },
  data () {
    return {
      distributionCollegeTypes
    }
  },
  methods: {
    parseDate,
    maxDate (date1, date2) {
      return date1 > date2 ? date1 : date2
    },
    hasPerformerCollege () {
      return this.distribution.college === distributionCollegeTypes.PERFORMER || this.distribution.college === distributionCollegeTypes.MAKER_AND_PERFORMER
    },
    hasMakerCollege () {
      return this.distribution.college === distributionCollegeTypes.MAKER || this.distribution.college === distributionCollegeTypes.MAKER_AND_PERFORMER
    }
  },
  watch: {
    "distribution.periodEnd": function (value) {
      this.distribution.openPeriodStartMaker = moment(value).add(1, "month").startOf("month").toDate()
      this.distribution.openPeriodEndMaker = moment(value).add(4, "year").toDate()
      this.distribution.openPeriodStartPerformer = moment(value).add(1, "month").startOf("month").toDate()
      this.distribution.openPeriodEndPerformer = moment(value).add(6, "year").toDate()
    }
  }
}
</script>
